import { IonInput, IonItem, IonLabel } from '@ionic/react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import Button from '../../../components/Button'
import { useStepsContext } from '../../../context/StepsContext'
import useRequests from '../../../hooks/useRequests'
import { saveClientPin } from '../../../redux/actions'

const PinVerificationPY = () => {
  const { newProcedureStep, setNewProcedureStep }: { newProcedureStep: number; setNewProcedureStep: any } =
    useStepsContext()
  const { reSendPin } = useRequests('lineValidationPYForm')
  const [pin, setPin]: any = useState('')
  const dispatch = useDispatch()
  const regExNumberOnly = /^\d+$/
  const [error, setError] = useState('')

  const onContinue = async () => {
    dispatch(saveClientPin(pin))
    setNewProcedureStep(newProcedureStep + 1)
  }

  const handleChange = (event: any) => {
    const value = event.detail.value
    if (!value || regExNumberOnly.test(value)) setError('')
    if (value && !regExNumberOnly.test(value)) setError('Ingresar sólo números')
    setPin(value)
  }

  const validity = Boolean(pin.length < 4 || error)

  return (
    <main className="form">
      <div className="form-container">
        <h2 className="form-title">
          Ingresá el PIN enviado al <br /> cliente por SMS
        </h2>
        <IonItem shape="round">
          <IonLabel position="floating">PIN de portabilidad</IonLabel>
          <IonInput
            id="pin-verificador-ion-input-pin"
            name="pin"
            value={pin}
            inputMode="numeric"
            type="text"
            minlength={4}
            maxlength={4}
            autocomplete="off"
            onIonChange={handleChange}
          ></IonInput>
        </IonItem>
        {error && <span className="input-error">{error}</span>}
      </div>
      <div className="form-bottom-buttons">
        <Button
          id="verify-pin-continue"
          label="Continuar"
          className="submit-button"
          validity={validity}
          handleSubmit={onContinue}
        />
        <Button id="resend-pin" label="Reenviar PIN" className="secondary-outline-button" handleSubmit={reSendPin} />
      </div>
    </main>
  )
}

export default PinVerificationPY
